
import React from 'react';
import { Button } from '@/components/ui/button';
import { CalendarClock, RefreshCw, FileDown } from 'lucide-react';

interface PaymentHeaderProps {
  showBiweeklyReport: boolean;
  onToggleReport: () => void;
  onGenerateReport: () => void;
  onExportReport: (format: 'csv' | 'pdf') => void;
}

const PaymentHeader: React.FC<PaymentHeaderProps> = ({
  showBiweeklyReport,
  onToggleReport,
  onGenerateReport,
  onExportReport,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between">
      <div>
        <h2 className="text-xl font-medium">Referrer Payment Management</h2>
        <p className="text-muted-foreground">
          Process and manage redemption payments to referrers
        </p>
      </div>
      <div className="flex flex-wrap gap-2 mt-4 md:mt-0">
        <Button 
          onClick={onToggleReport}
          variant={showBiweeklyReport ? "default" : "outline"}
        >
          <CalendarClock className="mr-2 h-4 w-4" />
          {showBiweeklyReport ? "Hide Report" : "Biweekly Report"}
        </Button>
        <Button 
          onClick={onGenerateReport}
          variant="outline"
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Generate Report
        </Button>
        <Button 
          onClick={() => onExportReport('csv')}
          variant="outline"
        >
          <FileDown className="mr-2 h-4 w-4" />
          Export CSV
        </Button>
      </div>
    </div>
  );
};

export default PaymentHeader;
